import APIService from '@/services/APIService.js';

export default {
  getRelatorioConsulta(id) {
    return APIService.apiCall().get(`/consultas/getConsulta/${id}`);
  },
  getCanBeRenderd(id) {
    return APIService.apiCall().get(`/consultas/getCanBeRenderd/${id}`);
  },
  getRelatoriosConsultas(consultaInterna, includeExpiredRecords) {
    return APIService.apiCall().get(`/consultas/getConsultas?interna=${consultaInterna}&expirado=${includeExpiredRecords}`);
  },
  getRelatorios(relatorioId) {
    return APIService.apiCall().get(`/consultas/relatorios/${relatorioId}`);
  },
  getRelatoriosModelosGroups() {
    return APIService.apiCall().get('/gruposRelatorios');
  },
  getGrupoRelatoriosModeloChildren(id) {
    return APIService.apiCall().get(`/consultasModelos/get_by_grupo_relatorio/${id}`);
  },
  postRelatorio(dataRelatorio, id = null, uid) {
    const postData = { ...dataRelatorio };
    if (id) {
      return APIService.apiCall().post(`/consultas/edit/${uid}/${id}`, JSON.stringify(postData));
    }
    return APIService.apiCall().post(`/consultas/edit/${uid}`, JSON.stringify(postData));
  },
  postRelatorioModelo(postData) {
    return APIService.apiCall().post(`/consultas/add_modelo/${postData.modelo_id}`, JSON.stringify(postData));
  },
  getRelatorioSpreadSheet(id, tipo, config = {}) {
    return APIService.apiCall().get(`/consultas/get_planilha/${id}/${tipo}`, { responseType: 'blob', ...config });
  },
  baixarArquivoPlanilha(id, config = {}) {
    return APIService.apiCall().get(`/consultas/baixar_arquivo_planilha/${id}`, { responseType: 'blob', ...config });
  },
  getRelatoriosFavoritosUsuario(consultaInterna, includeExpiredRecords) {
    return APIService.apiCall().get(
      `/consultas/getConsultasFavoritasUsuario?interna=${consultaInterna}&expirado=${includeExpiredRecords}`
    );
  },
  favoritar(consulta_id) {
    return APIService.apiCall().get(`/consultas/favoritar/${consulta_id}`);
  },
  getConsultasByModeloId(id) {
    return APIService.apiCall().get(`/consultas/getConsultasByModeloId/${id}`);
  },
  getConsultaModelo(id) {
    return APIService.apiCall().get(`/consultasModelos/get/${id}`);
  },
  duplicar(id) {
    return APIService.apiCall().get(`/consultas/duplicar/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/consultas/executar/${id}`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/consultas/delete/${id}`);
  },
  getConsultasByStatus(status) {
    return APIService.apiCall().get(`/consultas/getConsultasByStatus/${status}`);
  },
  preVisualizarConsulta(id) {
    return APIService.apiCall().get(`/consultas/visualizar/${id}`);
  },
  getLastConsultaFilhaByModeloId(idModelo) {
    return APIService.apiCall().get(`/consultas/getLastConsultaFilhaByModeloId/${idModelo}`);
  },
  getHintValores(campo, tabela) {
    return APIService.apiCall().get(`/consultas/getHintValores?campo=${campo}&tabela=${tabela}`);
  },
  gerarCustomCSV(postData) {
    return APIService.apiCall().post(`/consultas/gerar_arquivo_custom_csv`, JSON.stringify(postData));
  },
  getConsultaInterna(id) {
    return APIService.apiCall().get(`/consultas/getInternaStatus/${id}`);
  },
  setConsultaInterna(id, data) {
    return APIService.apiCall().post(`/consultas/setInternaStatus/${id}`, JSON.stringify(data));
  },
  agendar(id, postData) {
    return APIService.apiCall().post(`/consultas/agendar/${id}`, JSON.stringify(postData));
  },
  getAgendamento(id) {
    return APIService.apiCall().get(`/consultas/getAgendamento/${id}`);
  }
};
